// angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// CC-Common imports
import { IconConstants } from 'cc-common';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';

// service imports
import { ServerErrorService } from '../../../_services/shared-services/server-error.service';
import { WorkflowSharedService } from '../../_services/workflow-shared.service';

// model imports
import { BoardApprovalRulesResultDto } from '../../_models/board-approval-rules-result-dto';
import { WFParametersDto } from '../../_models/wf-parameter-dto';

@Component({
    selector: 'app-workflow-board-approval-viewer',
    templateUrl: './workflow-board-approval-viewer.component.html',
    styleUrls: ['./workflow-board-approval-viewer.component.scss']
})
export class WorkflowBoardApprovalViewerComponent implements OnInit {
    @ViewChild('boardApprovalPopup', { static: false }) boardApprovalPopup: DxPopupComponent;

    @Input() communityId: number;
    @Output() onClose = new EventEmitter<void>();

    visible = false;

    boardApprovalRules: BoardApprovalRulesResultDto;

    iconClose = IconConstants.CROSS_MARK;

    constructor(
        private readonly workflowSharedService: WorkflowSharedService,
        private readonly errorService: ServerErrorService
    ) {}

    ngOnInit() {
        this.show();
    }

    show(): void {
        this.visible = true;
        this.populateBoardApprovalRules();
    }

    onPopupShown(): void {
        this.boardApprovalPopup.instance.repaint();
    }

    onPopupClose(): void {
        this.visible = false;
        this.onClose.emit();
    }

    private populateBoardApprovalRules(): void {
        const baseParam: WFParametersDto = new WFParametersDto();
        baseParam.communityId = this.communityId;

        this.workflowSharedService.getBoardApprovalRules(baseParam).subscribe(
            (result: BoardApprovalRulesResultDto) => {
                this.boardApprovalRules = result;
            },
            (error) => {
                this.errorService.displayError(error);
            }
        );
    }
}
